// Env-gated Sentry init. Only fires when both:
//   - `@sentry/react` is installed (dynamic import - lazy)
//   - VITE_SENTRY_DSN is set
// Safe to call unconditionally at boot; is a no-op otherwise.
//
// The dynamic import goes through a variable + `@vite-ignore` so Rollup
// doesn't try to resolve `@sentry/react` at build time - the SDK is
// intentionally an optional peer, added only in environments that use it.
export async function initMonitoring() {
  const dsn = import.meta.env.VITE_SENTRY_DSN
  if (!dsn) return
  try {
    const pkg = '@sentry/react'
    const Sentry = await import(/* @vite-ignore */ pkg)
    Sentry.init({
      dsn,
      environment: import.meta.env.VITE_APP_MODE || 'production',
      tracesSampleRate: Number(import.meta.env.VITE_SENTRY_TRACES ?? 0.1),
      replaysSessionSampleRate: 0,
      replaysOnErrorSampleRate: 1.0,
    })
  } catch {
    // SDK not installed - silently ignore, no user-visible failure.
  }
}
